var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card card-alert",
      class: [_vm.readonly === true ? "readOnly" : "normalMode"],
    },
    [
      _c("div", { staticClass: "card-inner" }, [
        _c("div", { staticClass: "card-row" }, [
          _c("div", { staticClass: "title-container" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("profile.sound_effect.other_sound.heading")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _vm._m(0),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-row" }, [
          _c(
            "div",
            { staticClass: "content-container" },
            [
              _c(
                "BFormCheckbox",
                {
                  staticClass: "switcher mt-3",
                  attrs: {
                    disabled: _vm.readonly,
                    value: "1",
                    "unchecked-value": "0",
                    switch: "",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.modification("config")
                    },
                  },
                  model: {
                    value: _vm.sounds.start_stop_session.value,
                    callback: function ($$v) {
                      _vm.$set(_vm.sounds.start_stop_session, "value", $$v)
                    },
                    expression: "sounds.start_stop_session.value",
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "profile.sound_effect.other_sound.start_stop_session.description"
                        )
                      )
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "BFormCheckbox",
                {
                  staticClass: "switcher mt-3",
                  attrs: {
                    disabled: _vm.readonly,
                    value: "1",
                    "unchecked-value": "0",
                    switch: "",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.modification("config")
                    },
                  },
                  model: {
                    value: _vm.sounds.critical_status.value,
                    callback: function ($$v) {
                      _vm.$set(_vm.sounds.critical_status, "value", $$v)
                    },
                    expression: "sounds.critical_status.value",
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "profile.sound_effect.other_sound.critical_status.description"
                        )
                      )
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "BFormCheckbox",
                {
                  staticClass: "switcher mt-3",
                  attrs: {
                    disabled: _vm.readonly,
                    value: "1",
                    "unchecked-value": "0",
                    switch: "",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.modification("config")
                    },
                  },
                  model: {
                    value: _vm.sounds.text_to_speech.value,
                    callback: function ($$v) {
                      _vm.$set(_vm.sounds.text_to_speech, "value", $$v)
                    },
                    expression: "sounds.text_to_speech.value",
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "profile.sound_effect.other_sound.text_to_speech.description"
                        )
                      )
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "BFormCheckbox",
                {
                  staticClass: "switcher mt-3",
                  attrs: {
                    disabled: _vm.readonly,
                    value: "1",
                    "unchecked-value": "0",
                    switch: "",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.modification("config")
                    },
                  },
                  model: {
                    value: _vm.sounds.discreet_mode.value,
                    callback: function ($$v) {
                      _vm.$set(_vm.sounds.discreet_mode, "value", $$v)
                    },
                    expression: "sounds.discreet_mode.value",
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "profile.sound_effect.other_sound.discreet_mode.description"
                        )
                      )
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", {
        staticClass: "fa fa-bell-slash",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }